import * as Yup from 'yup';

export const BullionDeskValidationSchema = Yup.object({
  buy: Yup.number()
    .positive('Buying price must be positive')
    .integer('Buying price must be an integer')
    .required('Buying price is required'),
  sell: Yup.number()
    .positive('Selling price must be positive')
    .integer('Selling price must be an integer')
    .required('Selling price is required'),
  exchange: Yup.number()
    .positive('Exchange price must be positive')
    .integer('Exchange price must be an integer')
    .required('Exchange price is required'),
  // locker_sell: Yup.number()
  //   .required('Locker Sell price is required')
  //   .integer('Must be an integer')
  //   .positive('Must be a positive number'),
  // locker_buy: Yup.number()
  //   .required('Locker Buy price is required')
  //   .integer('Must be an integer')
  //   .positive('Must be a positive number'),
  // saving_plan_sell: Yup.number()
  //   .required('Saving Plan Sell price is required')
  //   .integer('Must be an integer')
  //   .positive('Must be a positive number'),
  // saving_plan_buy: Yup.number()
  //   .required('Saving Plan Buy price is required')
  //   .integer('Must be an integer')
  //   .positive('Must be a positive number'),
});
